import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyTrackingPlansList = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	height: 206,
	viewBox: "0 0 255 206",
	width: 255,
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", { d: "m0 0h254.437v206h-254.437z" })
	}), /* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#a)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "m80.0883 6.204c-27.07 11.2644-42.605 38.6485-42.605 76.7448 0 38.0962-7.9291 33.0682-18.1326 52.3552-7.2858 13.772-3.3075 37.759 6.0563 48.943 12.9721 15.491 35.2814 21.845 60.3795 19.685 40.7625-3.508 43.5115-40.284 104.0555-25.208 28.824 7.178 54.727-17.592 62.547-52.929 4.691-21.202-5.126-49.9857-25.288-61.4199-27.479-15.5834-26.635-2.2552-57.071-35.9599-32.712-36.22558-60.805-34.33591-89.9417-22.2112z",
				fill: "#f3f5fd"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m152.936 18.2411-111.0205 17.6043 21.9304 138.3036 111.0211-17.605z",
				fill: "#b0c1db"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m64.8355 126.317c-.0979-.015-.1886-.06-.2588-.13-.0703-.07-.1164-.16-.1316-.258l-6.494-40.9572c-.0096-.0605-.0072-.1223.0071-.1818.0143-.0596.0401-.1158.0761-.1654.036-.0495.0814-.0915.1336-.1235.0523-.032.1103-.0534.1708-.063l94.0143-14.9071c.122-.0193.247.0106.347.0833s.167.1821.187.3042l6.493 40.9575c.01.06.007.122-.007.182-.014.059-.04.116-.076.165-.036.05-.081.092-.134.124-.052.032-.11.053-.171.062l-94.0132 14.908c-.0474.007-.0958.007-.1433 0zm-5.8906-41.0308 6.3478 40.0358 93.0923-14.761-6.349-40.036z",
				fill: "#fff",
				opacity: .3721
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m66.2541 135.264c-.1101-.017-.2107-.072-.2834-.156-.0728-.085-.113-.192-.1133-.304-.0003-.111.0392-.219.1114-.304.0723-.085.1725-.141.2825-.158l94.0137-14.907c.122-.02.247.01.347.083s.167.182.187.304c.019.123-.011.247-.084.347-.072.101-.182.168-.304.187l-94.0133 14.906c-.0475.008-.0959.009-.1436.002z",
				fill: "#fff",
				opacity: .3721
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m67.4429 142.761c-.1099-.017-.2101-.072-.2826-.157-.0725-.084-.1125-.192-.1128-.303s.0391-.219.1111-.303c.072-.085.1719-.141.2817-.159l94.0137-14.907c.061-.011.123-.009.184.004.06.014.117.039.168.075.05.036.093.082.126.135.032.052.054.111.064.172.009.061.007.124-.008.184s-.041.117-.078.167c-.037.049-.083.091-.137.123-.053.032-.112.052-.173.061l-94.0138 14.907c-.0474.008-.0958.008-.1433.001z",
				fill: "#fff",
				opacity: .3721
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m68.6315 150.258c-.1099-.017-.2102-.072-.2827-.157-.0726-.084-.1126-.191-.113-.303-.0003-.111.0391-.218.1111-.303s.1719-.141.2818-.159l94.0133-14.907c.122-.02.247.01.347.083s.168.182.187.304c.019.123-.011.247-.083.348-.073.1-.182.167-.305.186l-94.0128 14.907c-.0475.008-.096.009-.1437.001z",
				fill: "#fff",
				opacity: .3721
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m69.8204 157.756c-.1099-.017-.2102-.073-.2827-.157-.0726-.084-.1126-.192-.113-.303-.0003-.111.0391-.219.1111-.303.072-.085.172-.141.2818-.159l94.0134-14.908c.061-.009.123-.007.182.007.06.015.116.041.166.077.049.036.091.081.123.133s.053.11.063.171c.01.06.007.122-.007.182-.014.059-.04.115-.076.165s-.082.092-.134.124-.11.053-.171.063l-94.0131 14.907c-.0475.008-.0959.008-.1435.001z",
				fill: "#fff",
				opacity: .3721
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m57.0989 77.527c-.11-.0169-.2102-.0725-.2828-.1568-.0725-.0843-.1126-.1917-.1129-.3029-.0004-.1113.039-.2189.111-.3037.0721-.0847.172-.141.2818-.1585l94.014-14.9071c.122-.0194.247.0106.347.0833s.167.1822.186.3044c.02.1221-.01.247-.083.347-.073.1001-.182.1672-.304.1865l-94.0138 14.9075c-.0475.0074-.0958.0075-.1433.0003z",
				fill: "#fff",
				opacity: .3721
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m86.4805 64.0269c-.11-.0169-.2102-.0725-.2828-.1568s-.1126-.1917-.113-.303c-.0003-.1112.0391-.2189.1111-.3036.072-.0848.172-.141.2818-.1586l63.2644-10.0316c.121-.0175.245.0134.344.0862.098.0727.164.1814.184.3025.019.1212-.01.245-.082.3447-.071.0997-.179.1673-.3.1882l-63.2643 10.0317c-.0474.0073-.0957.0074-.1432.0003z",
				fill: "#fff",
				opacity: .3721
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m146.645 33.5379-63.2637 10.0383.4678 2.9479 63.2629-10.0383z",
				fill: "#fff",
				opacity: .3721
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m85.0124 54.768c-.1099-.0169-.2102-.0725-.2827-.1568-.0726-.0843-.1126-.1917-.113-.3029-.0003-.1112.0391-.2189.1111-.3037.072-.0847.172-.1409.2818-.1585l63.2644-10.0314c.06-.0096.122-.0072.181.0071.06.0143.116.0402.166.0762.049.0359.091.0813.123.1336.032.0522.054.1102.063.1707.01.0605.008.1223-.007.1818-.014.0596-.04.1158-.076.1653-.036.0496-.081.0916-.133.1236-.053.032-.111.0534-.171.063l-63.2641 10.0307c-.0475.0078-.0959.0082-.1435.0013z",
				fill: "#fff",
				opacity: .3721
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m85.9915 110.955c-.0537.008-.1085.007-.1619-.003l-16.8846-3.302c-.06-.011-.1172-.035-.1682-.069-.0509-.033-.0948-.077-.1289-.128-.069-.102-.0944-.228-.0707-.349s.0946-.228.1971-.297.2283-.095.3495-.071l16.5966 3.245 13.4501-18.035c.0685-.0918.1683-.1551.2805-.178s.2288-.0037.3278.0539l13.3932 7.8049 10.881-8.4208c.064-.0492.139-.081.219-.0924s.161-.0018.236.0276l15.687 6.1618 7.048-12.9285c.059-.1085.159-.1891.278-.224.118-.0349.246-.0212.354.0379.109.0591.189.1589.224.2775.035.1185.021.246-.038.3545l-7.244 13.2881c-.055.1-.143.1766-.25.2154-.107.0389-.224.0372-.33-.0047l-15.823-6.2152-10.92 8.452c-.074.057-.163.09-.255.096-.093.006-.185-.015-.265-.062l-13.3054-7.7537-13.375 17.9367c-.0731.098-.1815.163-.3021.182z",
				fill: "#262626"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m64.7258 69.069c6.8324 1.0403 13.2145-3.655 14.2548-10.4874 1.0404-6.8324-3.655-13.2145-10.4874-14.2549-6.8324-1.0403-13.2145 3.6551-14.2548 10.4874-1.0404 6.8324 3.655 13.2145 10.4874 14.2549z",
				fill: "#f3f5fd"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m74.2542 46.792-7.643 9.9065-1.9599-12.3586c1.6238-.26 3.2829-.1962 4.8819.1876 1.5991.3839 3.1064 1.0802 4.4352 2.0489.096.0697.1923.1424.2858.2156z",
				fill: "#0cbc8b"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m78.9704 54.7394c.3555 2.2136.1055 4.4823-.7233 6.5655l-11.6361-4.6048 7.3573-10.1227c.0961.0697.1923.1424.2858.2156 2.532 1.9468 4.2202 4.7912 4.7163 7.9464z",
				fill: "#262626"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m70.3194 116.262c-.0793-.013-.1545-.044-.219-.092-.0646-.047-.1167-.11-.1519-.182-.0351-.072-.0523-.152-.05-.232s.0239-.159.0631-.229l12.7502-22.7711c.0323-.0577.0758-.1085.1279-.1492.0522-.0407.1119-.0706.1757-.088.0639-.0174.1305-.0218.1961-.0131s.1288.0304.1859.0638l18.1066 10.6106 9.91-9.4079c.07-.0656.156-.11.25-.1278.093-.0179.19-.0085.278.027l16.425 6.5897 18.055-21.3555c.042-.051.094-.0931.152-.124s.122-.0498.188-.0558c.065-.006.131.0011.194.021.063.0198.122.0519.172.0945s.092.0948.122.1535.048.1228.053.1886c.005.0657-.003.1318-.024.1944s-.054.1204-.097.1702l-18.287 21.6301c-.068.08-.159.136-.26.161-.101.026-.208.018-.305-.021l-16.462-6.6043-9.952 9.4453c-.078.074-.178.121-.285.133-.107.013-.216-.01-.309-.065l-17.9914-10.5429-12.502 22.3289c-.0495.088-.1248.16-.2158.204-.0909.044-.1933.06-.2934.045z",
				fill: "#fff"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m233.821 28.0506-115.378-17.5683-22.5071 147.8157 115.3781 17.568z",
				fill: "#dee8f5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m147.543 24.5335-21.441-3.2647-2.923 19.1945 21.441 3.2648z",
				fill: "#fff"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m216.109 83.3054-19.166-2.9182-7.007 46.0188 19.166 2.918z",
				fill: "#8ddbe0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m190.883 120.19-78.032-11.881-.894 5.867 78.032 11.881z",
				fill: "#c1d8ed"
			}),
			/* @__PURE__ */ _jsxs("g", {
				fill: "#fff",
				children: [
					/* @__PURE__ */ _jsx("path", { d: "m216.53 80.535-97.201-14.8006-.844 5.5412 97.202 14.8006z" }),
					/* @__PURE__ */ _jsx("path", { d: "m209.492 129.855-98.123-14.941 7.499-49.2497.922.1403-7.359 48.3284 96.279 14.66 7.359-48.3282.922.1404z" }),
					/* @__PURE__ */ _jsx("path", { d: "m137.228 71.2944-.922-.1404-7.007 46.019.922.14z" }),
					/* @__PURE__ */ _jsx("path", { d: "m214.864 91.4819-97.197-14.7999-.141.9222 97.197 14.8z" }),
					/* @__PURE__ */ _jsx("path", { d: "m213.914 97.7152-97.197-14.8-.141.9223 97.198 14.7999z" }),
					/* @__PURE__ */ _jsx("path", { d: "m212.965 103.948-97.197-14.7999-.14.9223 97.197 14.7996z" }),
					/* @__PURE__ */ _jsx("path", { d: "m212.016 110.181-97.197-14.7996-.141.9223 97.198 14.8003z" }),
					/* @__PURE__ */ _jsx("path", { d: "m211.067 116.414-97.197-14.8-.141.923 97.197 14.8z" }),
					/* @__PURE__ */ _jsx("path", { d: "m210.118 122.648-97.197-14.8-.141.922 97.198 14.8z" }),
					/* @__PURE__ */ _jsx("path", { d: "m177.723 77.4605-.923-.1404-7.007 46.0189.922.14z" }),
					/* @__PURE__ */ _jsx("path", { d: "m197.404 80.4573-.922-.1404-7.007 46.0191.922.14z" }),
					/* @__PURE__ */ _jsx("path", { d: "m205.22 154.815-29.459-4.486-1.603 10.531 29.459 4.486z" }),
					/* @__PURE__ */ _jsx("path", { d: "m207.73 138.328-97.201-14.801-.14.922 97.201 14.801z" }),
					/* @__PURE__ */ _jsx("path", { d: "m206.51 146.341-97.201-14.801-.14.922 97.201 14.801z" }),
					/* @__PURE__ */ _jsx("path", { d: "m221.669 46.7897-67.12-10.2201-.141.9222 67.12 10.2202z" }),
					/* @__PURE__ */ _jsx("path", { d: "m187.654 49.8091-34.325-5.2266-.14.9222 34.325 5.2266z" }),
					/* @__PURE__ */ _jsx("path", { d: "m219.096 63.6892-97.201-14.8005-.141.9222 97.201 14.8006z" }),
					/* @__PURE__ */ _jsx("path", { d: "m217.875 71.7021-97.201-14.8005-.14.9222 97.201 14.8006z" }),
					/* @__PURE__ */ _jsx("path", { d: "m223.251 36.3969-67.12-10.2201-.575 3.7776 67.12 10.2201z" })
				]
			})
		]
	})]
});
export { SvgEmptyTrackingPlansList as ReactComponent };
